export const iconClose = <svg viewBox="0 0 21 21" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
  <path d="M15.5801 5.68018L5.68058 15.5797" stroke="#FB4343" strokeLinecap="round"
        strokeLinejoin="round"/>
  <path d="M5.44336 5.91577L15.3429 15.8153" stroke="#FB4343" strokeLinecap="round"
        strokeLinejoin="round"/>
</svg>
